import { RowFormConfig } from '../row-form';
import { CrudFormItem } from './crud-form-item.interface';

export interface CrudFormRowFormItem extends CrudFormItem, RowFormConfig {
}
